// extracted by mini-css-extract-plugin
module.exports = {"title":"CpAYyK","image":"_3hH691","imageSolo":"_1Drq9d","discount":"_2PBxRg","text":"_3evGkE","imageContainer":"_32GMT0","countdown":"_3u2mLL"};